export const verticalDropdownItems = [
  {
    name: 'Airline Operations Technology',
    value: 'aot',
    key: 1,
  },
  {
    name: 'Customer Technology',
    value: 'ct',
    key: 2,
  },
  {
    name: 'Cybersecurity',
    value: 'cs',
    key: 3,
  },
  {
    name: 'Data, Analytics and Innovation',
    value: 'dai',
    key: 4,
  },
  {
    name: 'Office of the CDIO',
    value: 'ocdio',
    key: 5,
  },
  {
    name: 'Workspace Technology',
    value: 'wt',
    key: 6,
  },
];
